import useBranchOfficeSelect from 'Factories/filters/hooks/useBranchOfficeSelect';
import { useState, useEffect } from 'react';
import { loggerInfo } from 'utils/infoLog';
import { getCommunications } from '../../../Collaborators/services/collaborators';
import { getCampaignResultDetails } from './ResultDetails.services';
import {
	CampaignResultDetails,
	UseresultDetailsProps,
} from './ResultDetails.types';

const initial = {
	id: '',
	company: {
		id: null,
		name: null,
	},
	branchOffice: {
		id: null,
		name: null,
	},
	categories: [],
};

export const useFilters = ({ campaignId }: UseresultDetailsProps) => {
	const [communications, setCommunications] = useState<any[]>([]);
	const [selectedCommunication, setSelectedCommunication] = useState<any>();
	const [isLoadingCommunication, setLoadingCommunication] = useState<any>();
	const [selectedSector, setSelectedSector] = useState<any>();

	const handleSelectCommunication = (index: number) => {
		setSelectedCommunication(communications[index]);
		setLoadingCommunication(true);
		setTimeout(() => {
			setLoadingCommunication(false);
		}, 500);
	};

	const fetchCommunications = async () => {
		setLoadingCommunication(true);
		try {
			const { data } = await getCommunications(campaignId);
			setCommunications(data.content?.slice(0, data.content.length + 1) || []);
		} catch (error) {
			loggerInfo({
				data: error,
				context: 'campaign',
				location: 'fetchCommunications',
				payloadRequest: { campaignId },
			});
		} finally {
			setLoadingCommunication(false);
		}
	};

	const handleChangeSelectedSelector = (value: any) => setSelectedSector(value);

	useEffect(() => {
		fetchCommunications();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [campaignId]);

	useEffect(() => {
		const [firstCommunication] = communications;
		setSelectedCommunication({ ...firstCommunication });
	}, [communications]);

	const {
		branchOfficeOptions,
		selectedBranchOffice,
		isLoadingBranchOffice,
		handleSelectBranchOffice,
	} = useBranchOfficeSelect();

	const isLoadingHeader = isLoadingCommunication || isLoadingBranchOffice;

	return {
		communications,
		isLoadingCommunication,
		selectedCommunication,
		onSelectCommunication: handleSelectCommunication,
		branchOfficeOptions,
		selectedBranchOffice,
		isLoadingBranchOffice,
		handleSelectBranchOffice,
		selectedSector,
		handleChangeSelectedSelector,
		isLoadingHeader,
	};
};

export const useDetails = ({
	selectedCommunication,
	selectedBranchOffice,
	selectedSector,
	campaignId,
}: any) => {
	const [isLoading, setLoading] = useState(false);
	const [detailsData, setDetailsData] = useState<CampaignResultDetails>({
		...initial,
	});

	const fetchUserInfoDetails = async () => {
		setLoading(true);

		try {
			const { data }: any = await getCampaignResultDetails({
				campaignId: campaignId,
				branchOfficeId: selectedBranchOffice?.id,
				questionnaireId: selectedCommunication?.id,
				sector: selectedSector,
			});

			setDetailsData({ ...initial, ...data.content });
		} catch (error) {
			loggerInfo({
				data: error,
				context: 'campaign',
				location: 'fetchUserInfoDetails',
				payloadRequest: {
					campaignId,
					branchOfficeId: selectedBranchOffice?.id,
					questionnaireId: selectedCommunication?.id,
					sector: selectedSector,
				},
			});
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (selectedCommunication?.id) {
			fetchUserInfoDetails();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [campaignId, selectedBranchOffice?.id, selectedCommunication?.id]);

	return {
		detailsData,
		isLoading,
		onSearch: fetchUserInfoDetails,
	};
};
